/*global Modernizr, Splide, DDSlideCurrentSlide, DDSlideHideArrows, DDSlideDisableDrag */
/*jslint browser:true */

(function() {
    'use strict';

    var alerts_container = document.getElementById('dd-alerts');
    if(alerts_container) {
      var alert_slider = alerts_container.querySelector('.alert-slider'),
          close_alert = alerts_container.querySelector('.alerts-close');

      const slider = new Splide(alert_slider, {
        type: 'loop',
        pagination: false
      });

      slider.on('mounted resize', () => {
        if(slider.length <= slider.options.perPage) {
          slider.root.querySelector('.splide__arrows').classList.add('page-less');
        } else {
          slider.root.querySelector('.splide__arrows').classList.remove('page-less');
        }
      });

      slider.mount({ DDSlideCurrentSlide, DDSlideDisableDrag });

      close_alert.addEventListener('click', (e) => {
        e.preventDefault();

        document.cookie = 'DDClosedAlerts=true; max-age='+(12*60*60)+'; SameSite=lax; path=/';

        document.querySelector('.alerts-container').remove();
        document.body.classList.add('alerts-closed');
      });
    }
}());
